import * as Sentry from '@sentry/browser';
import { IGNORED_URLS } from '../consts';

Sentry.init({
  dsn: process.env.SENTRY_DASHBOARD_FRONTEND_DSN,
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      networkDetailAllowUrls: [window.location.origin],
      networkRequestHeaders: ['traceparent'],
      networkResponseHeaders: ['x-cloud-trace-context', 'x-am-session-status'],
    }),
  ],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  release: process.env.TAG_NAME,
  tracesSampleRate: 0.1,
  denyUrls: IGNORED_URLS,
  captureFailedRequests: true,
  skipOpenTelemetrySetup: true,
  beforeSend(event) {
    if (
      event.message === 'Failed to fetch' &&
      !(event?.breadcrumbs?.[0]?.data?.url || '').includes('ample')
    ) {
      return null;
    }

    if (event.exception?.values?.[0]?.type === 'CanceledError') {
      return null;
    }

    if (event.exception?.values?.[0]?.value?.includes('canceled')) {
      return null;
    }

    return event;
  },
  ignoreErrors: [
    'Event buffer exceeded maximum size of 20000000',
    'OTLPExporterError: Request Timeout',
    'DisconnectedError',
    'CanceledError',
    'canceled',
  ],
  tunnel: '/tunnel',
});

if (window.__AMPLEMARKET_USER_DATA__) {
  Sentry.setUser({
    id: window.__AMPLEMARKET_USER_DATA__['app.user.id'],
    username: window.__AMPLEMARKET_USER_DATA__['app.user.email'],
    email: window.__AMPLEMARKET_USER_DATA__['app.user.email'],
  });

  const userData = window.__AMPLEMARKET_USER_DATA__;
  const adminData = window.__AMPLEMARKET_ADMIN_DATA__;
  const parentAccountUserData = window.__AMPLEMARKET_PARENT_ACCOUNT_USER_DATA__;

  const user = {
    ...(userData || {}),
    ...(adminData || {}),
    ...(parentAccountUserData || {}),
  };

  Object.keys(user).forEach((key) => {
    Sentry.setTag(key, user[key]);
  });
}
